import type { SourceListItem } from "../../tars-hooks/useSourceList";
import type { SourceNode } from "../sidebar/sources-types";
import { isFile } from "../sidebar/sources-types";

export type DataBankElectionRef = {
    fsdId: number;
    electionKey: string;
};

export function dataBankSourceForElectionLabel(
    sources: SourceListItem[] | undefined,
    nodes: Record<string, SourceNode>,
    electionLabel: string
): DataBankElectionRef | null {
    const label = electionLabel.trim();
    if (!label) return null;

    for (const item of sources ?? []) {
        if (item.type !== "data_bank") continue;
        const more = item.more;
        if (more == null || typeof more !== "object") continue;
        const election = more.election_label;
        if (typeof election !== "string" || election.trim() !== label) continue;
        const fsdRaw = more.fsd_id;
        const fsdId = typeof fsdRaw === "number" ? fsdRaw : Number(fsdRaw);
        if (Number.isFinite(fsdId) && fsdId > 0) {
            return { fsdId, electionKey: label };
        }
    }

    for (const node of Object.values(nodes)) {
        if (!isFile(node) || node.type !== "dataBank") continue;
        if (node.data_bank_election?.trim() !== label) continue;
        const fsdId = node.data_bank_fsd_id;
        if (fsdId != null && fsdId > 0) {
            return { fsdId, electionKey: label };
        }
    }

    return null;
}

export function partyNamesFromElectionData(data: unknown): string[] {
    if (data == null || typeof data !== "object") return [];
    const candidates = (data as { candidates?: unknown }).candidates;
    if (!Array.isArray(candidates)) return [];

    const names: string[] = [];
    for (const row of candidates) {
        if (row == null || typeof row !== "object") continue;
        const party = (row as { party?: unknown }).party;
        if (typeof party === "string" && party.trim() !== "") {
            names.push(party.trim());
        }
    }
    return [...new Set(names)].sort((a, b) => a.localeCompare(b));
}
